import { render, staticRenderFns } from "./settingsBook.vue?vue&type=template&id=c3c03a12&"
import script from "./settingsBook.vue?vue&type=script&lang=js&"
export * from "./settingsBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports